import { useTranslation } from 'react-i18next';
import { useNavigationMenuTitle } from 'src/app/hooks/use-navigation-menu-title';
import { useAppSelector } from 'src/app/hooks';
import { ConvElectricCostPvReport as ElectricCostReport } from './electric-cost-report';
import { PlantSelector } from '../plant-selector/plant-selector';

export const CostReport = () => {
  const { t } = useTranslation();
  useNavigationMenuTitle(t('menu:costReports'));
  
  return (
    <div>
      <PlantSelector selectionMode={'single'} />
      <ElectricCostReport />
    </div>
  );
};
